import { isNumber, round, get, uniqBy, reduce } from 'lodash'
import server from '../../../../../Server/index'
import { vsName as reportingServerName } from '../../../../../../../reporting/server'
import machineModals from '../../../../../../common/services/modalWindow'

MachinesDetailConfigurationsConfigurationController.$inject = ['$confirm', '$state', server.vsName, '$uibModal', reportingServerName]
function MachinesDetailConfigurationsConfigurationController($confirm,
  $state,
  machineServer,
  $uibModal,
  reportingServer
) {
  var vm = this
  vm.$onInit = $onInit

  vm.machineConfiguration = get(vm, 'machineChange.MachineConfiguration') || {}


  vm.edit = edit
  vm.delete = deleteConfiguration
  vm.makeCurrent = makeCurrent
  vm.summary = showSummaryModal
  vm.addReview = addReview
  vm.reviewedBeforeModification = reviewedBeforeModification

  reportingServer.getReportGroup('machine').then(rg => {
    vm.reportGroup = rg
  })

  function $onInit() {
    vm.machineConfiguration = get(vm, 'machineChange.MachineConfiguration') || {}

    const gameConfigurations = vm.machineConfiguration.GameConfigurations || []
    vm.averagePar = calculateAveragePar(gameConfigurations)
    vm.averageProgressiveIncrementPercentage = calculateAverageParWithProgressiveIncrementPercentage(gameConfigurations)
    vm.averageRtp = calculateAverageRtp(vm.machineConfiguration)
    vm.multiGame = uniqBy(gameConfigurations, gameConfiguration => gameConfiguration.ThemeId).length > 1
    vm.multiDenom = uniqBy(gameConfigurations, gameConfiguration => gameConfiguration.DenominationId).length > 1

    machineServer.getMachineConfigurationReviews(vm.machineConfiguration.Id).then(reviews => {
      vm.configurationReviews = reviews
    })
  }

  function reviewedBeforeModification(review) {
    const reviewDate = new Date(review.ReviewTime)
    const modifiedDate = new Date(vm.machineConfiguration.ModifiedDate)

    return modifiedDate > reviewDate
  }

  function showSummaryModal(machineChange) {
    const configurationChangeId = machineChange.MachineConfiguration.MachineConfigurationChangeActionId
    machineServer.configurationChangeAction(configurationChangeId)
      .then(function (result) {
        $uibModal.open(machineModals.modalChangeAction(result))
      })
  }

  function edit() {
    $state.go('main.machines.machine.edit', getStateParams())
  }

  function deleteConfiguration() {
    $confirm({
      text: 'Are you sure you want to delete this configuration?'
    })
      .then(function () {
        return machineServer.machineConfigurationDelete(vm.machineConfiguration)
      })
      .then(function () {
        $state.go('main.machines.machine.configurations', getStateParams(), {
          reload: true
        })
      })
  }

  function calculateAverageRtp(machineConfiguration) {
    const minRtp = machineConfiguration.MinRtp
    const maxRtp = machineConfiguration.MaxRtp

    if (!isNumber(minRtp) || !isNumber(maxRtp)) {
      return undefined
    }

    const average = (minRtp + maxRtp) / 2

    return round(average, 3)
  }

  function makeCurrent(machineConfiguration) {
    machineServer.machineConfigurationMostRecentForDate(machineConfiguration)
      .then(function () {
        $state.go('main.machines.machine.configurations', getStateParams(), {
          reload: true
        })
      })
  }


  function getStateParams() {
    return {
      machineId: vm.machineConfiguration.MachineId,
      machineConfigurationId: vm.machineConfiguration.Id
    }
  }

  function addReview() {
    machineServer.addMachineConfigurationReview(vm.machineConfiguration.Id)
      .then(newReview => {
        const reviews = vm.configurationReviews
        const existingReview = reviews.find(review => review.Reviewer.UserAuthId === newReview.Reviewer.UserAuthId)
        if (!existingReview) {
          reviews.push(newReview)
          return
        }

        reviews.splice(reviews.indexOf(existingReview), 1, newReview)
      })
  }
}

function calculateAveragePar(gameConfigurations) {
  var count = (gameConfigurations && gameConfigurations.length) ? gameConfigurations.length : 0
  var totalPar = reduce(gameConfigurations, function (sum, config) {
    return sum + config.Par
  }, 0)

  return totalPar / count
}

function calculateAverageParWithProgressiveIncrementPercentage(gameConfigurations) {
  var count = (gameConfigurations && gameConfigurations.length) ? gameConfigurations.length : 0
  var totalPar = reduce(gameConfigurations, function (sum, config) {
    return sum + config.Par + (config.ProgressiveIncrementPercentage || 0)
  }, 0)

  return totalPar / count
}

export default MachinesDetailConfigurationsConfigurationController
